import styled from 'styled-components';

// NOTE: red and black bannerColors have been deprecated during rebrand
// available colors are now black and transparent
// TODO: content models to be updated following rebrand go-live
const getBackgroundCol = (colorTheme) => {
  switch (colorTheme) {
    case 'transparent':
      return 'transparent';
    default:
      return 'darkBackground';
  }
};

const getTextCol = (colorTheme) => {
  switch (colorTheme) {
    case 'transparent':
      return 'standardText';
    default:
      return 'white';
  }
};

export const Banner = styled.section`
  // transparent banner acts as an invisible container, no padding required
  padding: ${({ theme, $bannerColor }) =>
    ($bannerColor === 'transparent' && '0') || `${theme.spacing.standard} 0`};

  background-color: ${({ $bannerColor, theme }) =>
    theme.palette[getBackgroundCol($bannerColor)]};

  margin-bottom: ${({ $removeMarginBottom, $sidebar, theme }) =>
    ($removeMarginBottom && '0') ||
    ($sidebar && theme.spacing.standard) ||
    theme.spacing.large};
`;

export const Header = styled.h3`
  color: ${({ $bannerColor, theme }) =>
    theme.palette[getTextCol($bannerColor)]};
  margin-top: 0;
  margin-bottom: ${({ theme }) => theme.spacing.standard};
`;
